module.exports = __webpack_public_path__ + "static/winners-mr-monopoly-c54c2c069bc6376b80f61e0924a5bbdc.png";